<template>
  <div class="create-container">
    <div style="margin-bottom: 20px">
      <!--返回临时工账号列表-->
      <el-button
        icon="el-icon-back" size="small" plain
        @click="closeWindow(false)"
      >{{ $t('userManage.ReturnListTemporaryWorkerAccounts') }}</el-button>
    </div>
    <div style="margin-bottom: 20px;">
      <!--批量创建临时工账号-->
      <div class="create-title">{{ $t('userManage.CreateTemporaryWorkerAccountsBulk') }}</div>
      <!--通过 Excel 批量导入并创建当前 HUB 的临时工账号-->
      <div style="font-size: 14px">{{ $t('userManage.ImportAndCreateTemporaryWorkerAccounts') }}</div>
    </div>
    <div class="steps-all">
      <steps :active-steps="activeSteps" />
    </div>
    <div>
      <uploadFile
        v-if="activeSteps === 1"
        :site-id-list="siteIdList"
        @submitUploadFile="submitUploadFile"
      />
      <verification
        v-if="activeSteps === 2"
        :key="verificationKey"
        :site-id-list="siteIdList"
        :validate-data="validateData"
        @createAccounts="createAccounts"
        @submitUploadFile="submitUploadFile"
      />
      <createdSuccess
        v-if="activeSteps === 3"
        :key="createDataKey"
        :site-id-list="siteIdList"
        :create-data="createData"
        @closeWindow="closeWindow"
      />
    </div>
  </div>
</template>
<script>
import steps from './steps.vue';
import uploadFile from './uploadFile.vue';
import verification from './verification.vue';
import createdSuccess from './createdSuccess.vue';
export default {
  name: 'CreateAccount',
  components: { steps, uploadFile, verification, createdSuccess },
  props: {
    siteIdList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      activeSteps: 1,
      validateData: null,
      verificationKey: new Date().getTime(),
      createData: null,
      createDataKey: new Date().getTime()
    };
  },
  methods: {
    // 关闭弹窗
    closeWindow(type) {
      this.$emit('closeWindow', type);
    },
    // 上传校验进入步骤2
    submitUploadFile(type, data) {
      this.validateData = data;
      this.verificationKey = new Date().getTime();
      this.activeSteps = type;
    },
    // 提交创建账号进入步骤3
    createAccounts(type, data) {
      this.activeSteps = type;
      this.createData = data;
      this.createDataKey = new Date().getTime();
    }
  }
};
</script>

<style scoped>
.create-container {
  background:#f5f7f9;
  padding: 20px;
  min-height: 100%;
}
.create-title {
  font-size: 20px;
  font-weight: bold;
  color:#000;
}
.steps-all {
  background:#fff;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
}
</style>
